import { Routes, Route } from 'react-router';
import { AnonymousLayout } from './components/layouts/AnonymousLayout';
import { DashboardLayout } from './components/layouts/DashboardLayout';
import { ProtectedRoute } from './components/ProtectedRoute';

// Pages
import { LoginPage } from './pages/LoginPage';
import { SignupPage } from './pages/SignupPage';
import { LogoutPage } from './pages/LogoutPage';
import { DashboardPage } from './pages/DashboardPage';
import { AppsPage } from './pages/AppsPage';
import { AppDetailsPage } from './pages/AppDetailsPage';
import { ServicesPage } from './pages/ServicesPage';
import { ServiceCatalogPage } from './pages/ServiceCatalogPage';
import { ServiceDetailsPage } from './pages/ServiceDetailsPage';
import { AddServicePage } from './pages/AddServicePage';
// import { ArchivePage } from './pages/ArchivePage';
import { MFilesConnectionsPage } from './pages/MFilesConnectionsPage';
import { MFilesInvoicePage } from './pages/MFilesInvoicePage';
import { MFilesMyobPage } from './pages/MFilesMyobPage';
import { MFilesXeroPage } from './pages/MFilesXeroPage';
import { SubscriptionPage } from './pages/SubscriptionPage';
import { SubscriptionRequestPage } from './pages/SubscriptionRequestPage';
import { UsagePage } from './pages/UsagePage';
import { ProfilePage } from './pages/ProfilePage';
import { ProfileSecurityPage } from './pages/ProfileSecurityPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { UnauthorizedPage } from './pages/UnauthorizedPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { NotificationsPage } from './pages/NotificationsPage';

// Smart Correct pages
import { SmartCorrectListPage } from './pages/smart-correct/SmartCorrectListPage';
import { SmartCorrectSetupPage } from './pages/smart-correct/SmartCorrectSetupPage';
import { SmartCorrectDetailPage } from './pages/smart-correct/SmartCorrectDetailPage';
import { SmartCorrectVendorsPage } from './pages/smart-correct/SmartCorrectVendorsPage';
import { SmartCorrectSuggestionsPage } from './pages/smart-correct/SmartCorrectSuggestionsPage';
import { SmartCorrectConfigPage } from './pages/smart-correct/SmartCorrectConfigPage';
import { SmartCorrectDataPage } from './pages/smart-correct/SmartCorrectDataPage';

// Doc pages
import { DocAppsPage } from './pages/docs/AppsPage';
import { DocServicesPage } from './pages/docs/ServicesPage';

export function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route element={<AnonymousLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
      </Route>

      {/* Authenticated routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<DashboardLayout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/apps" element={<AppsPage />} />
          <Route path="/apps/:id" element={<AppDetailsPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/catalog" element={<ServiceCatalogPage />} />
          <Route path="/services/add" element={<AddServicePage />} />
          <Route path="/services/:id" element={<ServiceDetailsPage />} />
          <Route path="/services/archive" element={<ServicesPage />} />
          <Route path="/connections/mfiles" element={<MFilesConnectionsPage />} />
          <Route path="/connections/mfiles/invoice" element={<MFilesInvoicePage />} />
          <Route path="/connections/mfiles/myob" element={<MFilesMyobPage />} />
          <Route path="/connections/mfiles/xero" element={<MFilesXeroPage />} />
          <Route path="/subscription" element={<SubscriptionPage />} />
          <Route path="/subscription/request" element={<SubscriptionRequestPage />} />
          <Route path="/usage" element={<UsagePage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/profile/security" element={<ProfileSecurityPage />} />
          <Route path="/profile/notifications" element={<NotificationsPage />} />
          <Route path="/smart-correct" element={<SmartCorrectListPage />} />
          <Route path="/smart-correct/setup" element={<SmartCorrectSetupPage />} />
          <Route path="/smart-correct/:id" element={<SmartCorrectDetailPage />} />
          <Route path="/smart-correct/:id/config" element={<SmartCorrectConfigPage />} />
          <Route path="/smart-correct/:id/vendors" element={<SmartCorrectVendorsPage />} />
          <Route path="/smart-correct/:id/suggestions" element={<SmartCorrectSuggestionsPage />} />
          <Route path="/smart-correct/:id/data" element={<SmartCorrectDataPage />} />
          <Route path="/help/contact" element={<ContactPage />} />
          <Route path="/docs/apps" element={<DocAppsPage />} />
          <Route path="/docs/services" element={<DocServicesPage />} />
        </Route>
      </Route>

      {/* Logout — outside ProtectedRoute so it works even after session cleared */}
      <Route path="/logout" element={<LogoutPage />} />

      {/* Error pages */}
      <Route path="/401" element={<UnauthorizedPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}